import { FC } from 'react'

import { Button, IconArrowUpRight, Link } from '@sequencehq/core-components'

import { isProductionOrDemoEnv } from 'lib/environment/environment'
import { quickbooksAdvancedSettingsUrl } from './integrationSyncErrorLink'

export const OpenQuickbooksSettingsAction: FC<{ 'data-testid'?: string }> = ({
  'data-testid': dataTestId
}) => (
  <Button
    as={Link.Unstyled}
    to={quickbooksAdvancedSettingsUrl(isProductionOrDemoEnv())}
    target="_blank"
    rel="noopener noreferrer"
    variant="secondary"
    leadingIcon={<IconArrowUpRight />}
    data-testid={dataTestId}
  >
    Open QuickBooks settings
  </Button>
)
